module.exports = __webpack_public_path__ + "static/scale-model-of-magic-fun-house-castle-in-garland-texas-e6f5c9f9a6729753a1cc8ff33bde6fbc.png";